import { render, staticRenderFns } from "./requirementsModal.vue?vue&type=template&id=8c88e8f6&scoped=true"
import script from "./requirementsModal.vue?vue&type=script&lang=js"
export * from "./requirementsModal.vue?vue&type=script&lang=js"
import style0 from "./requirementsModal.vue?vue&type=style&index=0&id=8c88e8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c88e8f6",
  null
  
)

export default component.exports